/**
 * Local constants for the Image Quality (evidence capture quality) page.
 */

/**
 * Feature flag for the Evidence Image Quality and Associate Scorecards pages (RnRRCCFacadeService
 * IsFeatureEnabled, FeatureGating.RCC_IMAGE_QUALITY.AllowedUsers). Fails closed.
 */
export const IMAGE_QUALITY_FEATURE_NAME = 'RCC_IMAGE_QUALITY';

/** Associate's pass-rate direction vs the previous period. */
export enum AssociateTrend {
  IMPROVING = 'IMPROVING',
  DECLINING = 'DECLINING',
  FLAT = 'FLAT',
}

/** Colour band for a pass rate, from the backend-supplied thresholds. */
export type QualityTier = 'good' | 'warn' | 'bad';

/** Associate cohort by image quality (from the backend thresholds). */
export enum Cohort {
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
}

/**
 * The two associate lists the report sends until it sends every associate: its best few and its
 * bottom share. They stand in for the threshold cohorts until then.
 */
export enum ListCohort {
  BEST_FEW = 'BEST_FEW',
  BOTTOM_SHARE = 'BOTTOM_SHARE',
}

/** A cohort, a list cohort, or '' for everyone. */
export type CohortFilter = Cohort | ListCohort | '';

/** Photos per page; also the most links one batch request asks for. */
export const PHOTO_PAGE_SIZE = 12;
